/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Placeholders_SelectInputs */

const en_placeholders_select = /** @type {(inputs: Placeholders_SelectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Select {name}" |
*
* @param {Placeholders_SelectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const placeholders_select = /** @type {((inputs: Placeholders_SelectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeholders_SelectInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_placeholders_select(inputs)
});